import { z } from 'zod'
import { ContractSchema } from '../contract.js'
import { CoverageSchema } from '../coverage.js'
import { OcrResultSchema } from '../ocr.js'

export const ContractsResponseSchema = z.array(ContractSchema)
export type ContractsResponse = z.infer<typeof ContractsResponseSchema>

export const ContractUploadResponseSchema = z.object({
  contract: ContractSchema,
  coverages: z.array(CoverageSchema),
  ocr: OcrResultSchema,
})
export type ContractUploadResponse = z.infer<typeof ContractUploadResponseSchema>

// Issued by POST /api/contracts/upload-session for the QR phone-upload flow.
// `upload_url` is the raw API endpoint; the desktop FE encodes a frontend
// phone-upload page URL built from `upload_token` into the QR instead.
export const UploadSessionResponseSchema = z.object({
  upload_token: z.string().min(1),
  upload_url: z.string().url(),
  expires_at: z.string(),
})
export type UploadSessionResponse = z.infer<typeof UploadSessionResponseSchema>

export const ContractConfirmRequestSchema = z.object({
  contract: ContractSchema.partial().required({ id: true }),
  coverages: z.array(CoverageSchema).optional(),
})
export type ContractConfirmRequest = z.infer<typeof ContractConfirmRequestSchema>

export const ContractConfirmResponseSchema = z.object({
  contract: ContractSchema,
  coverages: z.array(CoverageSchema),
})
export type ContractConfirmResponse = z.infer<typeof ContractConfirmResponseSchema>
